import comp from "./ShortcutTooltip";
export default comp;
